import { borderRadius, reference, label } from "@carvana/helios-styles";
import { useFlags } from "launchdarkly-react-client-sdk";
import styled from "styled-components";

const HeaderBetaBadge = () => {
  const { auctionShowAdesaBetaFlag } = useFlags();

  return auctionShowAdesaBetaFlag ? <BetaBadge>BETA</BetaBadge> : null;
};

const BetaBadge = styled.span`
  ${label.xs};
  border-radius: ${borderRadius.sm};
  border: 1px solid ${reference.cyan[700]};
  padding: 2px ${borderRadius.sm};
  color: ${reference.cyan[700]};
  font-size: 7px;
  line-height: 9px;
`;

export default HeaderBetaBadge;
